import { render, staticRenderFns } from "./norm-weight-toggle.vue?vue&type=template&id=9c910e3e&scoped=true"
import script from "./norm-weight-toggle.vue?vue&type=script&lang=js"
export * from "./norm-weight-toggle.vue?vue&type=script&lang=js"
import style0 from "./norm-weight-toggle.vue?vue&type=style&index=0&id=9c910e3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c910e3e",
  null
  
)

export default component.exports